import { Component, OnInit, Type } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastMsg, ToastmsgService } from './toastmsg.service';

@Component({
  selector: 'app-toastmsg',
  templateUrl: './toastmsg.component.html',
  styleUrls: ['./toastmsg.component.css']
})
export class ToastmsgComponent implements OnInit {
  showMsg = false;
  toastmsgsubs: Subscription;
  msgItems : ToastMsg = {msg : "", msgType : "I", msgTitle:"Information"}
  constructor(private toasMsgService: ToastmsgService) { 
    this.toastmsgsubs = this.toasMsgService.getMsgSubs().subscribe(toastMsg => {
      if (toastMsg.msg) {
        this.msgItems = toastMsg;
        this.showMsg = true;
        setTimeout(() => {
          this.hideMsg();
        }, 5000);
      }
    })
  }

  ngOnInit(): void {
  }

  hideMsg() {
    this.msgItems = { msg: "", msgType: "I", msgTitle: "Information" }
    this.showMsg = false;
  }

}
